export const ko = {
  brand: '모당',
  common: {
    next: '다음',
    prev: '이전',
    confirm: '확인',
    cancel: '취소',
    submit: '제출',
    loading: '잠시만 기다려주세요…',
    error: '문제가 발생했어요. 잠시 후 다시 시도해주세요.',
    retry: '다시 시도',
  },
  auth: {
    login: '로그인',
    logout: '로그아웃',
    signup: '무당 회원가입',
    email: '이메일',
    password: '비밀번호',
    passwordHelp: '8자 이상',
  },
  booking: {
    pageTitle: '예약하기',
    pickDate: '날짜를 선택해주세요',
    pickTime: '시간을 선택해주세요',
    customerName: '이름',
    customerBirth: '생년월일',
    customerPhone: '휴대전화번호',
    customerGender: '성별',
    male: '남자',
    female: '여자',
    privacyConsent: '개인정보 수집·이용에 동의합니다 (필수)',
    paymentMethod: '결제 방법',
    payToss: '토스로 바로 결제',
    payVa: '가상계좌 입금',
    payVaHelp: '발급된 계좌로 입금하시면 자동으로 확정됩니다.',
    bookingClosed: '현재 예약을 받지 않습니다.',
  },
  subscription: {
    statusActive: '구독 중',
    statusPastDue: '결제 실패 — 결제 수단을 갱신해주세요',
    statusPaused: '서비스 일시중지',
    statusCanceled: '구독 해지됨',
  },
} as const;
